<script>
import de from "../locale/de.json";
import en from "../locale/en.json";
import fr from "../locale/fr.json";
import it from "../locale/it.json";
import { HTTP } from "../utils/httpSettings";
//import rootStore from "../store/root";

import Vue from "vue";
const eventBus = new Vue();

export default {
	data: () => {
		var d = {
			language: "en",
			languages: {
				de: de,
				en: en,
				fr: fr,
				it: it
			},
			languageUpdate: 0
		};
		d.i18n = d.languages[d.language];
		return d;
	},
	created() {
		var _this = this;
		eventBus.$on("languageChanged", lang => {
			_this.__setLanguage(lang);
		});
	},
	methods: {
		__(k) {
			if (!this.i18n) {
				debugger;
			}
			var v = this.i18n[k];
			if (v) return v;
			return k;
		},
		__changeLanguage(lang) {
			HTTP.defaults.headers["ACCEPT-LANGUAGE"] = lang;
			eventBus.$emit("languageChanged", lang);
		//	rootStore.dispatch("countries", lang);
		},
		__setLanguage(lang) {
			if (!this.languages[lang]) lang = "en";
			// we need to use this stupid trick to bootstrap the yet unloaded HalbtaxMixin instances properly..
			window.halbtax_currentLanguage = lang;
			this.language = lang;
			this.i18n = this.languages[this.language];
		//	rootStore.dispatch("countries", lang);
			this.$data.languageUpdate++;
		}
	}
};
</script>
